/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader } from '@zeeve-platform/loader-component';
import Urls from '../../../utils/urls';

import { prefixPath } from '../../../utils/helpers';
import Paginate from '../../pagination/paginate';
import NetworkCard from '../../common/cards/networkCard';
import BreadCrumb from '../../common/breadCrumb/BreadCrumbComponent';
import RightButtons from '../../common/buttons/addButtonComponent';
import apiBackendInstance from '../../../utils/axios';

export interface networkDataInterface {

  id: string,
  name: string,
  type: string,
  protocolId?: string,
  workspaceId: string,
  activeNodes: number,
  inactiveNodes: number,
  inProgressNodes: number,
  frontendBaseSuburl: string,
  customDashboardUrl?: string,
  protocolName: string,
  createdAt?: string,
  nodeType?: string | null,
  protocolType: 'public' | 'permissioned' | 'hybrid' | 'sidechain',
  status: string,
}

const StakingNetworkBody = ({ theme }: { theme: string }) => {
  const [networkData, setNetworkData] = useState<networkDataInterface[]>([]);
  const [showLoader, setShowLoader] = useState(true);
  const loaderImageUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);
  const [renderPagination, setRenderPagination] = useState(false);
  const [networkDataLength, setNetworkDataLength] = useState(0);

  async function getPage(offset: number, limit: number): Promise<boolean> {
    try {
      setShowLoader(true);
      const response = await apiBackendInstance.get(Urls.getAllNetworkList(offset, limit, 'staking'), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (response && response.data && response.data.data && response.data.data.networkList) {
        setNetworkData(response.data.data.networkList);
        setShowLoader(false);
        return true;
      }
      console.log('didnt get  data right here is the response : ', response);
    } catch (error) {
      setShowLoader(false);
      console.log(error);
    }
    return false;
  }
  useEffect(() => {
    setShowLoader(true);
    apiBackendInstance.get(Urls.getAllNetworkList(0, 7, 'staking'), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data && response.data.data.networkList) {
        const { networkList } = response.data.data;
        const networkListCount = Number(response.data.data.totalNetworkCount);
        console.log(networkListCount);
        if (networkListCount > 7) {
          setNetworkDataLength(networkListCount);
          setRenderPagination(true);
        }
        setNetworkData(networkList);
      }
      setShowLoader(false);
    }).catch((err) => {
      setNetworkData([]);
      setRenderPagination(false);
      setShowLoader(false);
      console.error(err);
    });
  }, []);

  const imgSubPath = window.location.origin;
  const addIconImg = imgSubPath + prefixPath(`/img/${theme}/add-icon.png`);
  const toDedicatedSubscriptions = prefixPath('/network/subscriptions');
  localStorage.setItem('from', 'validatornode');

  return (
    <section className="px-5 col-12 workspace">
      {showLoader && <Loader imagePath={loaderImageUrl} />}
      <div className="cardBlack">
        <div className="row mt-4 pt-1">
          <BreadCrumb breadcrumbURI="Validator Node Network" />
          <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 cursor button-add">
            <div className="d-flex justify-content-end">
              <RightButtons theme={theme} name="Add Node / Network" path={toDedicatedSubscriptions} />
            </div>
          </div>
          <div className="mt-2 row">
            {
              networkData.map((o, idx) => (
                <NetworkCard
                  cardnumber={idx}
                  type={o.type}
                  total={networkData.length}
                  key={o.id}
                  id={o.id}
                  name={o.name}
                  protocolId={o.protocolId}
                  workspaceId={o.workspaceId}
                  activeNodes={o.activeNodes}
                  inactiveNodes={o.inactiveNodes}
                  inProgressNodes={o.inProgressNodes}
                  frontendBaseSuburl={o.frontendBaseSuburl}
                  customDashboardUrl={o.customDashboardUrl}
                  protocolName={o.protocolName}
                  createdAt={o.createdAt}
                  card_type="allStakingNetwork"
                  nodeType={o.nodeType}
                  protocolType={o.protocolType}
                  status={o.status}
                />
              ))
            }
            <div className="col-lg-4 col-xl-3 col-md-5 col-sm-12 mt-5 cursor mg-auto">
              <div className="workSpaceCard cursor " style={{ height: '100%' }}>
                <Link to={toDedicatedSubscriptions} style={{ textDecoration: 'none' }}>
                  <div className="card-body text-center add-workspace">
                    <div className="mt-4 mx-auto">
                      <img className="mt-2 mb-3" src={addIconImg} alt="" />
                    </div>
                    <h6 className="mt-2 activeTextColor">New Network</h6>
                    <p>
                      Deploy Your Validator Node and Monitor Your Blockchain Node
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Paginate totalItems={networkDataLength} itemsPerPage={7} renderPagination={renderPagination} getPage={getPage} pageLimit={7} />
    </section>
  );
};

export default StakingNetworkBody;
